// VERSION: v6.1.39
// IMPORTANT: When updating taas_app version data, update the version number in this comment on the first line
// This version number is used by the backend API endpoint get_VersionData
export const versionContentData = {
  date: 'December 9, 2025',
  marketAccessVersion: 'v1.9.205',
  features: [
    {
      title: 'New',
      items: [
        {
          title: 'Extended',
          description: 'Extended trading now available.',
        },
        {
          title: 'Market Maker Grid Modes',
          description: "New 'grid modes' parameter lets you control how the Market Maker bot trades the grid.",
        },
      ],
    },
  ],
};
